/**
 * Application Configuration
 * Centralized configuration for API URLs and environment settings
 */

export const config = {
  // API Configuration
  api: {
    baseUrl: getApiBaseUrl(),
    endpoints: {
      contact: '/api/contact',
      health: '/api/health',
      partner: '/api/contact/partner/submit',
      investor: '/api/contact/investor/submit'
    }
  },
  
  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

/**
 * Get API Base URL based on environment
 */
function getApiBaseUrl(): string {
  // Check for environment variable first
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Default to localhost in development
  if (import.meta.env.DEV) {
    return 'http://localhost:5000';
  }

  // Production URL - Backend deployed on Render
  // This works for all production domains:
  // - https://neurosedge.ai
  // - https://neurosedge.com
  // - https://neuros-edge.vercel.app
  return 'https://neurosedge-backend.onrender.com';
}

export default config;
